import Styles from './Toolbar.module.scss'
import { PropsWithChildren } from 'react'

export const Section = ({ children }: PropsWithChildren) => <div className={Styles.section}>{children}</div>
